// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__P6CwV","clinicsSelect":"TableHeading_clinicsSelect__C5Bcq"};